import { useNavigate } from "react-router-dom"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu"
import { User, LogOut, ChevronDownIcon } from "lucide-react"
import { useAuth0 } from "@auth0/auth0-react"
import { getHostInfo } from "utils/networking"

type UserMenuProps = {
  username: string
  userTitle?: string
}

const UserMenu = ({ username, userTitle }: UserMenuProps) => {
  const navigate = useNavigate()
  const { logout } = useAuth0()
  const { logoutUrl } = getHostInfo()

  const handleLogout = async () => {
    await logout({
      logoutParams: {
        returnTo: logoutUrl,
      },
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center px-2 py-1 text-sm text-black hover:bg-zinc-100 rounded-md focus:outline-none">
        <div className="flex items-center justify-start gap-1">
          <span aria-label="User profile menu">{username}</span>
          {userTitle && (
            <span className="text-xs text-zinc-900">{userTitle}</span>
          )}
          <ChevronDownIcon className="w-4 h-4" />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          onClick={() => navigate("/profile")}
          className="cursor-pointer"
        >
          <User className="w-4 h-4 mr-2" />
          My Account
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { UserMenu }
